import React, { Component } from 'react';
import { format } from "date-fns";
import { Big3Common } from '../../js/IncludeManager'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from 'swiper';
import "swiper/css";
import 'swiper/css/pagination';
import 'swiper/css/navigation';

/* 개발담당:이재호
 * 화면기능:메인 팝업
 * 세부설명:
*/

export class FullPopupAd extends Component {
    static displayName = FullPopupAd.name;

    constructor(props) {

        super(props);
        this.state = {
            FullPopupAdList: [],
            ShowPopup : true
        };
        this.VirtualRoot = Big3Common.WebConfig.EventImageVirtualPath();
        this.storedDate = Big3Common.WebStorage.GetLocalStorage("FullPopupAd");
        this.ads_close_type_cd = '';
        this.closeDate = '';
        this.toDay = format(Big3Common.Util.DateAdd(new Date(), 0), "yyyy-MM-dd");
        if (this.storedDate > this.toDay) {
            this.state.ShowPopup = false;
        }
        this.handleDateClose_Click = this.handleDateClose_Click.bind(this);
        this.Uid_Type = Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.Uid_Type)
    }
    //초기화
    async componentDidMount() {
        await this.GetPopup();
        
    }
    //팝업 리스트 가져오기
    async GetPopup() {
        try {
            Big3Common.Util.LoadingOn();
            const Data = await Big3Common.Post('api/AdMgr/PopupAd/GetFullScreen', { uid_type: this.Uid_Type });
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const FullPopupAdList = JSON.parse(Data.dataTable);
                               
                this.setState({ 
                    FullPopupAdList: FullPopupAdList,
                });
                if (!this.ads_close_type_cd && FullPopupAdList.length > 0) {
                    this.ads_close_type_cd = parseInt(FullPopupAdList[0].ads_close_type_cd, 10);
                    if (this.ads_close_type_cd === 99) {
                        this.ads_close_type_cd = 9999
                    }
                    this.closeDate = format(Big3Common.Util.DateAdd(new Date(), this.ads_close_type_cd), "yyyy-MM-dd");
                }
                if (this.state.ShowPopup === true && FullPopupAdList.length > 0 && window.innerWidth <= 680) {
                    document.body.style.overflow = 'hidden';
                }
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("GetPopup", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
        }
    }
    //오늘 그만보기
    handleDateClose_Click = (event) => {
        Big3Common.WebStorage.SetLocalStorage("FullPopupAd", this.closeDate);
        this.setState({ ShowPopup: false });
        document.body.style.overflow = 'auto';
        event.preventDefault();
    }
    //닫기
    handleCloseClick = (event) => {
        Big3Common.WebStorage.SetLocalStorage("FullPopupAd", this.closeDate);
        this.setState({ ShowPopup: false });
        document.body.style.overflow = 'auto';
        event.preventDefault();
    }
    //팝업 클릭시 링크url로 전환
    handle_Location = (event, link_url) => {
        window.open(link_url, "_blank");
        event.preventDefault();
    }
    handle_innerLocation() {
        document.body.style.overflow = 'auto';
    }
    BannderRender = (list) => {
        return (
            <img src={`${this.VirtualRoot}/${list.file_path}`} alt="" />
        )
    }

    render() {
        const ShowPopup = this.state.ShowPopup
        const FullPopupAdList = this.state.FullPopupAdList
        const slidersCount = 1;

        if (!ShowPopup || FullPopupAdList.length === 0) {
            return null
        }
        return (
            <div className="full_popupbox" id={this.props.id}>
                <Swiper className="full_popupbox_img"
                    watchSlidesProgress={true}
                    slidesPerView={slidersCount}
                    modules={[Navigation]}
                    navigation
                    style={{"--swiper-navigation-color": "#B2B2B2"}}
                >
                    <div>
                        {
                            FullPopupAdList.map((list, idx) =>
                                <SwiperSlide key={list.ads_detail_id}>
                                    {this.BannderRender(list)}
                                    {idx === FullPopupAdList.length - 1 && (
                                        <button type="button" className="fc_close_btn" onClick={this.handleCloseClick}></button>
                                    )}
                                    <div className="fs_banner_page_number">
                                        <div>{idx + 1}</div>
                                        <div>/</div>
                                        <div>{FullPopupAdList.length}</div>
                                    </div>
                                </SwiperSlide>
                            )
                        }
                    </div>
                </Swiper>
{/*                <div className="bs_popup_footer">
                    <div className="bs_popup_footer_ios">
                        <button type="button" className="today_close" onClick={this.handleDateClose_Click} >{this.ads_close_type_cd}일간 그만보기</button>
                        <button type="button" className="close" onClick={this.handleCloseClick}>닫기</button>
                    </div>
                </div>*/}
            </div>
        )
    }
}
